module.exports = __webpack_public_path__ + "img/skiing.0a8f09b9.png";